// @flow
import React from 'react';

import BillboardDirect from 'components/billboard/BillboardDirect';
import BillboardHeaderNews from 'components/billboard/BillboardHeaderNews';
import type { CategoryArticleType } from 'types/Article';

type Props = {
  categoriesArticle: CategoryArticleType[]
};

function BillboardHeader({ categoriesArticle }: Props) {
  /**
   * Récupérer toutes les news puis :
   * - les trier par date
   * - enlever les doublons
   * - retourner uniquement les 6 dernières
   *
   * Peuplera la news centrale et les 5 premières du bloc En direct
   */
  const getNews = () => {
    let news = [];
    let ids = [];
    if (categoriesArticle && Array.isArray(categoriesArticle) && categoriesArticle.length > 0) {
      categoriesArticle.forEach(cat => {
        if (cat.items && cat.items.length > 0) {
          cat.items.forEach(actu => {
            news.push(actu);
          });
        }
      });
    }

    return news
      .filter(item => {
        return ids.indexOf(item.link) === -1 ? ids.push(item.link) : false;
      })
      .sort((a, b) => {
        var x = a.date.toString();
        var y = b.date.toString();
        return y < x ? -1 : y > x ? 1 : 0;
      })
      .slice(0, 6);
  };

  const news = getNews();

  return (
    <section className="billboard-header">
      {news && news.length > 0 && <BillboardHeaderNews categoriesArticle={categoriesArticle} news={news[0]} />}
      <BillboardDirect news={news} categoriesArticle={categoriesArticle} />
    </section>
  );
}

export default BillboardHeader;
